import { render, staticRenderFns } from "./ModificarHorario.vue?vue&type=template&id=7a80f374&scoped=true&"
import script from "./ModificarHorario.vue?vue&type=script&lang=js&"
export * from "./ModificarHorario.vue?vue&type=script&lang=js&"
import style0 from "./ModificarHorario.vue?vue&type=style&index=0&id=7a80f374&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a80f374",
  null
  
)

export default component.exports